/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import './_top.js'
import './_form.js'
import './_gallery.js'
import './_business.js'
import './_secret.js'

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.animatedを付加
// Intersection Observer
window.intObs = function () {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
window.intObs()

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######
const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    modalOverlay.classList.add('active')
    scrollLock('body', '#modalOverlay')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    modalOverlay.classList.remove('active')
    scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

//  ##   ##  ##  ####    #####   #####             #####   ##        ###    ##    ##
//  ##   ##  ##  ##  ##  ##     ##   ##            ##  ##  ##       ## ##    ##  ##
//  ##   ##  ##  ##  ##  #####  ##   ##  ########  #####   ##      ##   ##    ####
//   ## ##   ##  ##  ##  ##     ##   ##            ##      ##      #######     ##
//    ###    ##  ####    #####   #####             ##      ######  ##   ##     ##
// videoタグを自動再生させる
// videoタグのautoplay属性だとiPhoneの低電力モードで再生されない時に再生ボタンが出てしまうため

const videoPlayList = document.getElementsByClassName('js-videoPlay')
if (videoPlayList[0]) {
  for (const iterator of videoPlayList) {
    iterator.play()
  }
}
